import { render, staticRenderFns } from "./milestone_token.vue?vue&type=template&id=7f709866"
import script from "./milestone_token.vue?vue&type=script&lang=js"
export * from "./milestone_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports